export const toolFallbackStyles = {
  root: "my-2 rounded-lg border border-border bg-secondary text-sm",
  header: "border-b border-border px-3 py-1.5 font-mono text-xs font-medium text-mid",
  args: "overflow-x-auto px-3 py-2 font-mono text-xs text-muted-foreground",
  result: "overflow-x-auto border-t border-border px-3 py-2 font-mono text-xs text-mid",
};
